// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.collaborators-modal_modal_k28kX {
    width: min(38rem, calc(100vw - 2rem));
}

.collaborators-modal_body_oxMCf {
    padding: 1.5rem 2.25rem;
    max-height: calc(100vh - 15rem);
    overflow-y: auto;
    background: var(--ui-modal-background);
    color: var(--ui-modal-foreground);
}

.collaborators-modal_form_PiJJ9 {
    display: grid;
    gap: 0.5rem;
    margin-bottom: 1rem;
}

.collaborators-modal_form_PiJJ9 input,
.collaborators-modal_form_PiJJ9 select {
    width: 100%;
    height: 3rem;
    padding: 0 1rem;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 5px;
    background-color: var(--input-background);
    color: var(--text-primary);
    font-family: inherit;
    font-size: 0.875rem;
}

.collaborators-modal_button_dJGFH {
    padding: 0.75rem 1rem;
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    background: white;
    color: black;
    font-family: inherit;
    font-weight: 600;
    font-size: 0.85rem;
    cursor: pointer;
}

.collaborators-modal_button_dJGFH:disabled {
    opacity: 0.5;
    cursor: default;
}

.collaborators-modal_open-button_d13Un,
.collaborators-modal_form_PiJJ9 button[type="submit"] {
    justify-self: end;
    background: var(--looks-secondary);
    border-color: var(--looks-secondary);
    color: white;
}

.collaborators-modal_list_MKR4x {
    padding: 0;
    list-style: none;
}

.collaborators-modal_member_uvRki {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 0.5rem 0;
}

.collaborators-modal_name_M_pEI {
    flex: 1;
    overflow-wrap: anywhere;
}

.collaborators-modal_member_uvRki .collaborators-modal_avatar_YpqtX {
    width: 2rem;
    height: 2rem;
}

.collaborators-modal_member_uvRki .collaborators-modal_thumbnail_E2QXe {
    border-radius: calc(0.5rem / 2);
    box-shadow: 0 0 0 1px var(--ui-black-transparent);
}
`, "",{"version":3,"sources":["webpack://./src/components/dash-collaborators/collaborators-modal.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,+BAA+B;IAC/B,gBAAgB;IAChB,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,aAAa;IACb,WAAW;IACX,mBAAmB;AACvB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,6CAA6C;IAC7C,kBAAkB;IAClB,yCAAyC;IACzC,0BAA0B;IAC1B,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;IAC7C,sBAAsB;IACtB,iBAAiB;IACjB,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;;IAEI,iBAAiB;IACjB,kCAAkC;IAClC,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,OAAO;IACP,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,iDAAiD;AACrD","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal {\n    width: min(38rem, calc(100vw - 2rem));\n}\n\n.body {\n    padding: 1.5rem 2.25rem;\n    max-height: calc(100vh - 15rem);\n    overflow-y: auto;\n    background: var(--ui-modal-background);\n    color: var(--ui-modal-foreground);\n}\n\n.form {\n    display: grid;\n    gap: 0.5rem;\n    margin-bottom: 1rem;\n}\n\n.form input,\n.form select {\n    width: 100%;\n    height: 3rem;\n    padding: 0 1rem;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 5px;\n    background-color: var(--input-background);\n    color: var(--text-primary);\n    font-family: inherit;\n    font-size: 0.875rem;\n}\n\n.button {\n    padding: 0.75rem 1rem;\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    background: white;\n    color: black;\n    font-family: inherit;\n    font-weight: 600;\n    font-size: 0.85rem;\n    cursor: pointer;\n}\n\n.button:disabled {\n    opacity: 0.5;\n    cursor: default;\n}\n\n.open-button,\n.form button[type=\"submit\"] {\n    justify-self: end;\n    background: var(--looks-secondary);\n    border-color: var(--looks-secondary);\n    color: white;\n}\n\n.list {\n    padding: 0;\n    list-style: none;\n}\n\n.member {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    padding: 0.5rem 0;\n}\n\n.name {\n    flex: 1;\n    overflow-wrap: anywhere;\n}\n\n.member .avatar {\n    width: 2rem;\n    height: 2rem;\n}\n\n.member .thumbnail {\n    border-radius: calc(0.5rem / 2);\n    box-shadow: 0 0 0 1px var(--ui-black-transparent);\n}\n"],"sourceRoot":""}]);
// Exports
export var modal = `collaborators-modal_modal_k28kX`;
export var body = `collaborators-modal_body_oxMCf`;
export var form = `collaborators-modal_form_PiJJ9`;
export var button = `collaborators-modal_button_dJGFH`;
var _1 = `collaborators-modal_open-button_d13Un`;
export { _1 as "open-button" };
export var openButton = `collaborators-modal_open-button_d13Un`;
export var list = `collaborators-modal_list_MKR4x`;
export var member = `collaborators-modal_member_uvRki`;
export var name = `collaborators-modal_name_M_pEI`;
export var avatar = `collaborators-modal_avatar_YpqtX`;
export var thumbnail = `collaborators-modal_thumbnail_E2QXe`;
export default ___CSS_LOADER_EXPORT___;
